
	/**
	 * @description
	 *  Modelo de un ítem en una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/OrderEventItemForGetDto.cs
	 */

export class OrderEventItemForGet {

	public code: string;
	public id: number;
	public name: string;
	public orderEventId: number;
	public orderItemId: number;
	public price: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un ítem de una nota con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem en una nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventItemForGet {
		const orderEventItemForGet: OrderEventItemForGet = new OrderEventItemForGet();
		orderEventItemForGet.code = "";
		orderEventItemForGet.id = undefined;
		orderEventItemForGet.name = "";
		orderEventItemForGet.orderEventId = undefined;
		orderEventItemForGet.orderItemId = undefined;
		orderEventItemForGet.price = undefined;
		orderEventItemForGet.quantity = undefined;
		return orderEventItemForGet;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventItemForGet
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventItemForGet: OrderEventItemForGet): OrderEventItemForGet {
		if (!anemicOrderEventItemForGet) return undefined;
		const orderEventItemForGet: OrderEventItemForGet = OrderEventItemForGet.empty();
		orderEventItemForGet.code = anemicOrderEventItemForGet.code;
		orderEventItemForGet.id = anemicOrderEventItemForGet.id;
		orderEventItemForGet.name = anemicOrderEventItemForGet.name;
		orderEventItemForGet.orderEventId = anemicOrderEventItemForGet.orderEventId;
		orderEventItemForGet.orderItemId = anemicOrderEventItemForGet.orderItemId;
		orderEventItemForGet.price = anemicOrderEventItemForGet.price;
		orderEventItemForGet.quantity = anemicOrderEventItemForGet.quantity;
		return orderEventItemForGet;
	}
}
